import React from "react";
import { Rnd } from "react-rnd";
import { Card, CardHeader, IconButton, CardContent } from "@material-ui/core";
import { X } from "lucide-react";
import { useWidgetStore } from "../../store/widgetStore";

const FloatingWidget = ({ id, title, icon, children }) => {
  const { positions, zIndices, updatePosition, toggleWidget, bringToFront } =
    useWidgetStore();

  const pos = positions[id] || { x: 100, y: 100, width: 300, height: 350 };
  const currentZ = zIndices[id] || 1000;

  return (
    <Rnd
      size={{ width: pos.width || 300, height: pos.height || 350 }}
      position={{ x: pos.x, y: pos.y }}
      bounds="window"
      minWidth={220}
      minHeight={180}
      dragHandleClassName={`widget-drag-handle-${id}`}
      onDragStart={() => bringToFront(id)}
      onDragStop={(e, d) => {
        updatePosition(id, d.x, d.y, pos.width, pos.height);
      }}
      onResizeStop={(e, direction, ref, delta, position) => {
        updatePosition(
          id,
          position.x,
          position.y,
          parseInt(ref.style.width, 10),
          parseInt(ref.style.height, 10)
        );
      }}
      style={{
        zIndex: currentZ,
        position: "fixed",
      }}
      onMouseDown={() => bringToFront(id)}
    >
      <Card
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          borderRadius: 12,
          overflow: "hidden",
          border: "1px solid rgba(0, 0, 0, 0.08)",
        }}
      >
        <CardHeader
          className={`widget-drag-handle-${id}`}
          avatar={icon}
          title={title}
          style={{
            cursor: "move",
            backgroundColor: "#3f51b5",
            color: "#ffffff",
            padding: "8px 12px",
            userSelect: "none",
          }}
          titleTypographyProps={{
            variant: "subtitle2",
            style: { fontWeight: "bold", color: "#ffffff", fontSize: "0.875rem" },
          }}
          action={
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                toggleWidget(id);
              }}
              style={{ color: "#ffffff", padding: 4 }}
            >
              <X size={18} />
            </IconButton>
          }
        />
        <CardContent
          style={{
            flexGrow: 1,
            overflow: "auto",
            padding: 12,
            backgroundColor: "#fafafa",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </CardContent>
      </Card>
    </Rnd>
  );
};

export default FloatingWidget;
